export const GENERIC_IMAGE_PLACEHOLDER_PATH = '/generic_image_placeholder.webp';
